import React from 'react'

const CoreComponent19 = ({contents}) => {
  return (
    <div>
        <div className="row ">
          {contents.map((val, i) => (
            <div key={i} className=" col-lg-4">
              <div className={`row h-100`}>
                <div className={`col-12  px-3 py-2 d-flex flex-column justify-content-start   ${val.color? 'bg-dark text-white':'btn-light border text-black'}`} >
                  <img src={val.icon} className="my-2 mx-0 text-start" alt="" style={{width:50,height:50}}/>
                  <h2 className={`h2-heading text-start ${val.color? ' text-white':' text-black'} font-gordita opacity-75`}  style={{color:'#d3d3d3'}}>{val.num}</h2>
                  <h3 className={` text-start h3-heading lh-base   ${val.color? ' text-white':' text-black'}`}>{val.title}</h3>
                  <p className={`my-2 fs-6 lh-base  text-start h3-para lh-base  ${val.color? ' text-white':' text-black'}`}>{val.desc}</p>
                </div>
           
              </div>
            </div>
          ))}
        </div>
    </div>
  )
}

export default CoreComponent19